/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Ndaremovesuccess3Inputs */

const en_coinvestments_ndaremovesuccess3 = /** @type {(inputs: Coinvestments_Ndaremovesuccess3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NDA document removed successfully`)
};

/**
* | output |
* | --- |
* | "NDA document removed successfully" |
*
* @param {Coinvestments_Ndaremovesuccess3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_ndaremovesuccess3 = /** @type {((inputs?: Coinvestments_Ndaremovesuccess3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Ndaremovesuccess3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_ndaremovesuccess3(inputs)
});
export { coinvestments_ndaremovesuccess3 as "coInvestments_ndaRemoveSuccess" }